import { atom } from 'recoil';

/** localStorage key — đồng bộ với RecoilHeaderPreferenceHydrate & ProfileDrawer */
export const HEADER_SCROLL_HIDE_STORAGE_KEY = 'bsc_header_scroll_hide';

/**
 * true: header dùng kiểu ẩn khi cuộn (sticky + translate)
 * false: header luôn hiển thị cố định
 */
export const headerScrollHideEnabledState = atom<boolean>({
  key: 'headerScrollHideEnabledState',
  default: true,
});
